var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"tinymce-container",class:{ fullscreen: _vm.fullscreen }},[_c('textarea',{staticClass:"tinymce-textarea",attrs:{"id":_vm.tinymceId}})])])}
var staticRenderFns = []

export { render, staticRenderFns }